import { z, ZodType } from 'zod';

export const DASHBOARD_PERIODS = {
	lastDay: 'lastDay',
	last7Days: 'last7Days',
	last30Days: 'last30Days',
	last6Months: 'last6Months',
} as const satisfies Record<string, string>;

export type DashboardPeriod = (typeof DASHBOARD_PERIODS)[keyof typeof DASHBOARD_PERIODS];

export const dashboardPeriodSchema: ZodType<DashboardPeriod> = z.enum([
	DASHBOARD_PERIODS.lastDay,
	DASHBOARD_PERIODS.last7Days,
	DASHBOARD_PERIODS.last30Days,
	DASHBOARD_PERIODS.last6Months,
]);

export type DashboardSeriesParams = {
	metrics: string[];
	period: DashboardPeriod;
	timeZone: string;
	currency: string;
	accountIds?: number[];
};

export type DashboardSeriesPoint = {
	bucket: string;
	value: number;
};

export const dashboardSeriesPointSchema: ZodType<DashboardSeriesPoint> = z.object({
	bucket: z.string(),
	value: z.number(),
});

export type DashboardSeriesItem = {
	metric: string;
	total: number;
	points: DashboardSeriesPoint[];
};

export const dashboardSeriesItemSchema: ZodType<DashboardSeriesItem> = z.object({
	metric: z.string(),
	total: z.number(),
	points: dashboardSeriesPointSchema.array(),
});

export type DashboardSeriesResponse = {
	period: DashboardPeriod;
	currency: string;
	from: string;
	to: string;
	series: DashboardSeriesItem[];
};

export const dashboardSeriesResponseSchema: ZodType<DashboardSeriesResponse> = z.object({
	period: dashboardPeriodSchema,
	currency: z.string(),
	from: z.string(),
	to: z.string(),
	series: dashboardSeriesItemSchema.array(),
});
